<template>
  <!-- NOTE (TEMPLATE) to show the proposal of this university -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/university/postDocs'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-proposals) to show all proposals -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        @filtered="onFiltered"
        :filterIncludedFields="filterOn"
        empty-text="هنوز طرحی ثبت نشده است"
        empty-filtered-text="نتیجه‌ای برای نمایش یافت نشد"
        striped
        :busy="isBusy"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <!-- NOTE (<a>) to go to the "moshahedeh tarh" -->
          <div style="text-align: center; vertical-align: middle; width: 150px">
            <a
              class="btn btn-success mx-1"
              style="width: 100%"
              :href="'/university/postDoc/' + data.item.id"
              target="_blank"
              >مشاهده طرح</a
            >
          </div>
        </template>
        <template v-slot:cell(project_status)="data">
          <div
            v-if="data.item.project_status == 'ثبت شده'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-vimeo p-2" disabled
              >ثبت شده</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'درحال بررسی'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-xing p-2" disabled
              >درحال بررسی</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'در دست داوری'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-css3 p-2" disabled
              >در دست داوری</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'جمع بندی نظرات داوران'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-warning p-2" disabled
              >جمع بندی نظرات داوران</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'تایید نهایی'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-success" disabled
              >تایید نهایی</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'مرحله دوم'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-dark" disabled
              >مرحله دوم</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'نیاز به تکمیل / اصلاح'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-danger" disabled
              >نیاز به تکمیل / اصلاح</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'پذیرش اولیه'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-info p-2" disabled
              >پذیرش اولیه</b-button
            >
          </div>
          <div
            v-if="data.item.project_status == 'رد شده است'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-youtube p-2" disabled
              >رد شده</b-button
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,

      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "researcherName", label: "نام پژوهشگر" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
        { key: "operation", label: "عملیات" },
      ],
      // items: [{ faSubject: 'test1' , project_status: 'نیاز به تکمیل'}, { faSubject: 'test2', project_status: 'ثبت شده' }],
      items: [],
      filter: "",
      filterOn: [],
      isBusy: true,
    };
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      // NOTE (MOUNTED) to show the proposals data
      this.$http
        .post(
          this.baseUrl + "/setad/university/requests/postDoc/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.totalRows = this.items.length;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          // Error code is 401 ( BAAS Error code need revision)
          if (err.response.status == 401 || 403) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
  },

  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
